module.exports = __webpack_public_path__ + "static/media/CT_2019_30444A.29a80a64.png";